import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAddressCard,
  faList,
  faBriefcase,
  faPhone,
  // faQuestion,
  faUsers,
  faBlog,
  faBook,
  faHome,
  faTools,
  faUniversity
} from "@fortawesome/free-solid-svg-icons";
library.add(faAddressCard, faList, faBriefcase, faPhone, faHome);

const Navbar = ({ isActive }) => {
  const { sec } = useParams();

  const section = sec === "" || sec == null ? "top_menu" : sec;

  useEffect(() => {
    if (section !== null && section !== "") {
      document.getElementById(section).scrollIntoView();
    }
    // console.log(isActive);
  });

  return (
    <nav className=" [ navbar navbar-expand-lg navbar-fixed-top ] ">
      <Link
        to="/"
        className=" [ navbar-brand navbar__brand ] "
        aria-label="Seed To Tree Logo"
      >
        <div className=" [ d-flex align-items-center gap-1 ] ">
          <img
            loading="lazy"
            width={100}
            height={100}
            src="/assets/images/logos/logo.webp"
            alt="Seed To Tree primary navigation menu logo."
            title="Seed To Tree primary navigation menu logo."
          />{" "}
          SEED TO TREE
        </div>
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span
          className="navbar-toggler-icon"
          style={{ color: "#ffffff" }}
        ></span>
      </button>

      <div className=" [ collapse navbar-collapse ] " id="navbarNav">
        <ul className="[ navbar-nav ml-auto navbar__primary ] ">
         
          <li className=" [ nav-item active animated zoomIn ] ">
            <Link
              aria-label="Home"
              className={
                isActive === "home" ? " [ nav-link active ] " : "nav-link"
              }
              to="/"
            >
              <FontAwesomeIcon icon={faHome} />
              <span>Home</span>
            </Link>
          </li>

          <li className=" [ nav-item dropdown animated ] ">
            <Link
              aria-label="Courses Categories"
              className=" [ nav-link dropdown-toggle ] "
              data-bs-toggle="dropdown"
              // aria-hidden="true"
              aria-expanded="false"
            >
              <FontAwesomeIcon icon={faBook} /> <span>Courses</span>
            </Link>
            <ul className="dropdown-menu">
              <li className=" [ nav-item animated zoomIn ] ">
                <Link
                  aria-label="Courses"
                  className={
                    isActive === "courses"
                      ? " [ nav-link active ] "
                      : "nav-link"
                  }
                  to="/courses"
                >
                  <FontAwesomeIcon icon={faList} /> <span>All</span>
                </Link>
              </li>
              <li>
                <Link
                  aria-label="Arts | Courses Categories"
                  className={
                    isActive === "arts"
                      ? " [ dropdown-item active ] "
                      : "dropdown-item"
                  }
                  to="/courses/arts"
                >
                  Arts
                </Link>
              </li>

              <li>
                <Link
                  aria-label="it | Courses Categories"
                  className={
                    isActive === "it"
                      ? " [ dropdown-item active ] "
                      : "dropdown-item"
                  }
                  to="/courses/it"
                >
                  IT
                </Link>
              </li>
              <li>
                <Link
                  aria-label="Medical | Courses Categories"
                  className={
                    isActive === "medical"
                      ? " [ dropdown-item active ] "
                      : "dropdown-item"
                  }
                  to="/courses/medical"
                >
                  Medical
                </Link>
              </li>
            </ul>
          </li>
         
          <li className=" [ nav-item animated zoomIn ] ">
            <Link
              aria-label="Study in Türkiye"
              className={
                isActive === "study-in-turkey"
                  ? " [ nav-link ] "
                  : "nav-link"
              }
              to="/study-in-turkey"
            >
              <FontAwesomeIcon icon={faUniversity} />
              <span>Study in Türkiye</span>
            </Link>
          </li>

          <li className="[ nav-item dropdown animated ]">
            <Link
              aria-label="Services Categories"
              className="[ nav-link dropdown-toggle ]"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <FontAwesomeIcon icon={faTools} /> <span>Services</span>
            </Link>
            <ul className="dropdown-menu">
              <li className=" [ nav-item animated zoomIn ] ">
                <Link
                  aria-label="Services"
                  className={
                    isActive === "services"
                      ? " [ nav-link active ] "
                      : "nav-link"
                  }
                  to="/services"
                >
                  <FontAwesomeIcon icon={faList} /> <span>All</span>
                </Link>
              </li>
              <li className="[ nav-item animated zoomIn ]">
                <Link
                  aria-label="Web Design & Development"
                  to="/services#web-development"
                  duration={500}
                  className={
                    isActive === "web-development"
                      ? "[ dropdown-item active ]"
                      : "dropdown-item"
                  }
                >
                  Web Design & Development
                </Link>
              </li>
              <li className="[ nav-item animated zoomIn ]">
                <Link
                  aria-label="SEO Services"
                  to="/services#seo"
                  duration={500}
                  className={
                    isActive === "seo"
                      ? "[ dropdown-item active ]"
                      : "dropdown-item"
                  }
                >
                  SEO Services
                </Link>
              </li>
              <li className="[ nav-item animated zoomIn ]">
                <Link
                  aria-label="Social Media Marketing"
                  to="/services#social-media"
                  duration={500}
                  className={
                    isActive === "social-media"
                      ? "[ dropdown-item active ]"
                      : "dropdown-item"
                  }
                >
                  Social Media Marketing
                </Link>
              </li>
              <li className="[ nav-item animated zoomIn ]">
                <Link
                  aria-label="Medical Billing Services"
                  to="/services#medical-billing"
                  duration={500}
                  className={
                    isActive === "medical-billing"
                      ? "[ dropdown-item active ]"
                      : "dropdown-item"
                  }
                >
                  Medical Billing
                </Link>
              </li>
              <li className="[ nav-item animated zoomIn ]">
                <Link
                  aria-label="POS & Inventory Systems"
                  to="/services#pos-inventory"
                  duration={500}
                  className={
                    isActive === "pos-inventory"
                      ? "[ dropdown-item active ]"
                      : "dropdown-item"
                  }
                >
                  POS & Inventory Systems
                </Link>
              </li>
              <li className="[ nav-item animated zoomIn ]">
                <Link
                  aria-label="Website Maintenance"
                  to="/services#maintenance"
                  duration={500}
                  className={
                    isActive === "maintenance"
                      ? "[ dropdown-item active ]"
                      : "dropdown-item"
                  }
                >
                  Website Maintenance
                </Link>
              </li>
            </ul>
          </li>

          {/* <li className=" [ nav-item animated zoomIn ] ">
            <Link
              aria-label="Workshops | Home"
              className={
                isActive === "workshops" ? " [ nav-link active ] " : "nav-link"
              }
              to="#workshops"
            >
              <FontAwesomeIcon icon={faBriefcase} /> <span>Workshops</span>
            </Link>
          </li> */}

          {/* <li className=" [ nav-item animated zoomIn ] ">
            <Link
              aria-label="Why Choose Us | Home"
              className={
                isActive === "choose" ? " [ nav-link active ] " : "nav-link"
              }
              to="#whyUs"
            >
              <FontAwesomeIcon icon={faQuestion} />
              <span>Why Us</span>
            </Link>
          </li> */}
          {/* <li className=" [ nav-item animated zoomIn ] ">
            <Link
              aria-label="Community Page"
              className={
                isActive === "community" ? " [ nav-link active ] " : "nav-link"
              }
              to="/community"
            >
              <FontAwesomeIcon icon={faUsers} /> <span>Community</span>
            </Link>
          </li> */}

          <li className=" [ nav-item dropdown animated ] ">
            <Link
              aria-label="Community"
              className=" [ nav-link dropdown-toggle ] "
              data-bs-toggle="dropdown"
              // aria-hidden="true"
              aria-expanded="false"
            >
              <FontAwesomeIcon icon={faUsers} /> <span>Community</span>
            </Link>
            <ul className="dropdown-menu">
              <li className=" [ nav-item animated zoomIn ] ">
                <Link
                  aria-label="Community Page"
                  className={
                    isActive === "community"
                      ? " [ nav-link active ] "
                      : "nav-link"
                  }
                  to="/community"
                >
                  <FontAwesomeIcon icon={faUsers} /> <span>All</span>
                </Link>
              </li>
              <li>
                <Link
                  aria-label="Member | Community"
                  className={
                    isActive === "member community"
                      ? " [ dropdown-item active ] "
                      : "dropdown-item"
                  }
                  to="/community/member"
                >
                  Join as Member
                </Link>
              </li>
              <li>
                <Link
                  aria-label="Teacher | Community"
                  className={
                    isActive === "teacher community"
                      ? " [ dropdown-item active ] "
                      : "dropdown-item"
                  }
                  to="/community/teacher"
                >
                  Be a Teacher
                </Link>
              </li>
            </ul>
          </li>
          <li className=" [ nav-item animated zoomIn ] ">
            <Link
              aria-label="Blog Page"
              className={
                isActive === "blog" ? " [ nav-link active ] " : "nav-link"
              }
              to="/blog"
            >
              <FontAwesomeIcon icon={faBlog} /> <span>Blog</span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
